var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-3 pb-3 pl-5 pr-5 d-flex flex-column",attrs:{"id":"side-bar"}},[_c('SearchBar'),_c('v-row',{staticClass:"mt-5",attrs:{"no-gutters":""}},[_c('ConstraintsViewer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }